import React, {  useState, useEffect} from "react";
import { makeStyles,  } from "@material-ui/styles";
import {
  Grid,
  Paper,
  
} from "@material-ui/core";

import {DownloadButton} from "../utils/Download";

import Board from './Board'
import Landscape from './Landscape'
import Room from './Room'
import MaterialMenu from "./MaterialMenu";
import JimpImage from '../utils/JimpImage'
import asyncLogParams from "../components-logging/firebaseRealtime";

// const workerJimpImage = new window.Worker('../utils/JimpImage.js')

let sizeWindow
if (window.location.hostname === 'materialcomposer.web.app'){
  sizeWindow = "100%"
} else {
  sizeWindow = "470px"
}




const useStyles = makeStyles(() => ({
  root: {
    overflow: 'hidden',
    minHeight: '400px',
  },
  paper: {
    
    width: "100%",
    // height: "100%",
    // height: "470px",
    height: {sizeWindow},
    // minHeight: '100vh',
    minHeight: '430px',
    overflow: 'hidden',
    aspectRatio: "4/5 !important",

  },
  popover: {
    pointerEvents: 'none',
    width: "150px",
    height: "70px",
    
  },
  
}));


function Layout() {
  // console.log('Layout')
  const [material, setMaterial] = useState({
    zPrime: "Solanum Steel",
    ZSec: "Star Blue Copper",
    wood: "Walnut",
    nature: "Dewey Panic Grass",
    tile: "Marble",
    industrial: "Concrete",
  });
  const [matScene, setMatScene] = useState(false);
  const [download, setDownload] = useState(false);
  const [limitDowload, setLimitDowload] = useState(false);
  const [sceneIncrement, setSceneIncrement] = useState(0);
  const [spinner, setSpinner] = useState(false);
  const [UrlConfig, setUrlConfig] = useState('');

  useEffect( () => {
    
    if (download === true){
      setSpinner(true)
      // const objsetSpinner = JSON.parse(JSON.stringify(setSpinner));
      // const objasyncLogParams = JSON.parse(JSON.stringify(asyncLogParams));
      // const objUrlConfig = JSON.parse(JSON.stringify(UrlConfig));
      // const objlimitDowload = JSON.parse(JSON.stringify(limitDowload));
      // workerJimpImage.postMessage(objsetSpinner, objasyncLogParams, objUrlConfig, objlimitDowload)
      JimpImage(setSpinner, asyncLogParams, UrlConfig, limitDowload)
      setDownload(false)
      setLimitDowload(false)
    }
  }, [download,])

  const classes = useStyles();

  if (matScene === true){
    setSceneIncrement(sceneIncrement + 1) 
    setMatScene(false)
  }

  return (

    <div className={classes.root} style={{backgroundColor: '#ffffff'}} > {/*}style={{backgroundColor: '#F0E9F5'}}>*/}


      <Grid
        container
        spacing={4}
        flexgrow= {3}
        justifyContent="center"
        direction="row-reverse"
        
        style={{ padding: 10, alignContent:"center",  }}
      >
        

        {/* Landscape space */}
        <Grid container item xs={10} sm={4} >
          <div id='landscape' className={classes.paper}>
            <Paper
              color="secondary"
              variant="outlined"
              className={classes.paper}
              >
                <Landscape material={material} matScene={sceneIncrement} asyncLogParams={asyncLogParams} />
            </Paper>
            </div>
        </Grid>
        {/* <LandscapeBoard/> */}

        
        

        {/* room */}
        
        <Grid container item xs={10}  sm={4} 
        
        >
          <div id='room' className={classes.paper}>
              <Paper
                color="secondary"
                variant="outlined"
                className={classes.paper}
                
                >
                
                <Room material={material} asyncLogParams={asyncLogParams}/>
              </Paper>
          </div>
            
        </Grid>
        {/* <RoomBoard/> */}

        {/* <BoardBoard/> */}
        <Grid container item xs={10} sm={4} width= '10%'>
          <div id='board' className={classes.paper}>
            <Paper
              color="secondary"
              variant="outlined"
              className={classes.paper}
              >
              <Board material={material} asyncLogParams={asyncLogParams}/>
            </Paper>
            </div>
        </Grid>
        
        {/* Board */}


{/* bottom menues */}
      <Grid container 
      justifyContent="center"
      direction="row" 
      // justifyContent="flex-end"
      flexgrow = {3}
      spacing={2} 
      style={{ padding: 10, 
        // background: 'black',
       }}
       >

          <Grid  item  
          
          flexgrow = {3}
          flexwrap="wrap"
          style={{padding: '10px', alignItems: 'center', 
            }}>
            
            <Paper
              color="secondary"
              elevation={5} 
              style={{
                borderRadius: 75,
                backgroundColor: '#eeeeee',
                
              }}
              >
              

                <MaterialMenu 
                setMaterial={setMaterial} 
                material={material} 
                setMatScene={setMatScene} //Landscape trigger
                asyncLogParams={asyncLogParams}
                setUrlConfig={setUrlConfig}
                />
                
            </Paper>

          </Grid>


          <Grid container item xs={2} sm={2} 
          style={{  padding: '10px 1rem 10px 10px', alignContent: 'center',  }} >
          <DownloadButton setDownload={setDownload} spinner={spinner} setLimitDowload={setLimitDowload}/>
          {/* <DownloadButton /> */}
          </Grid >
        </Grid >
      </Grid>
      {/* </Grid> */}

    </div>
  );

}



export default Layout;


